/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Vb365OrganizationBaseEmbedded } from './vb365OrganizationBaseEmbedded';


export interface Vb365OrganizationBase { 
    /**
     * UID assigned to a Microsoft organization.
     */
    readonly instanceUid?: string;
    /**
     * Name of a Microsoft organization.
     */
    name: string;
    /**
     * Type of a Microsoft organization.
     */
    type: Vb365OrganizationBaseType;
    /**
     * Region where a Microsoft organization is located. > Available only for Microsoft 365 and hybrid organizations. 
     */
    readonly region?: Vb365OrganizationBaseRegion | null;
    /**
     * Authentication type of a Microsoft organization. Available only for Microsoft 365 and hybrid organization. 
     */
    readonly cloudAuthenticatedMethod?: Vb365OrganizationBaseCloudAuthenticatedMethod | null;
    /**
     * Array of protected Microsoft organization services.
     */
    readonly protectedServices?: Array<Vb365OrganizationBaseProtectedServices>;
    /**
     * UID assigned to a Veeam Backup for Microsoft 365 server.
     */
    readonly vb365ServerUid?: string;
    /**
     * Name of a Veeam Backup for Microsoft 365 server.
     */
    readonly vb365ServerName?: string;
    /**
     * UID assigned to a location of a management agent installed on a Veeam Backup for Microsoft 365 server. > If a Veeam Backup for Microsoft 365 server is not managed by Veeam Service Provider Console, the property value is `null`. 
     */
    locationUid?: string | null;
    /**
     * Name of a location of a management agent installed on a Veeam Backup for Microsoft 365 server. > If a Veeam Backup for Microsoft 365 server is not managed by Veeam Service Provider Console, the property value is `null`. 
     */
    locationName?: string | null;
    /**
     * Indicates whether the Microsoft organization files have been processed by a backup job.
     */
    readonly isBackedUp: boolean;
    /**
     * Date and time when Microsoft organization were processed by a backup job for the first time.
     */
    readonly firstBackupTime?: string | null;
    /**
     * Date and time when Microsoft organization files were processed by a backup job for the last time.
     */
    readonly lastBackupTime?: string | null;
    /**
     * Name of a Veeam Service Provider Console organization that registered a Microsoft organization. If a Microsoft organization was not created in Veeam Service Provider Console or was deleted, the property value is `null`. 
     */
    readonly registeredBy?: string | null;
    /**
     * Date and time when a Microsoft organization was registered. If a Microsoft organization was not created in Veeam Service Provider Console, the property value is `null`. 
     */
    readonly registrationDate?: string | null;
    /**
     * Indicates whether a Microsoft organization is currently being removed.
     */
    readonly isRemoving?: boolean;
    /**
     * Indicates whether job schedule can be enabled.
     */
    readonly isJobSchedulingEnabled?: boolean | null;
    /**
     * Detailed information about a Microsoft organization.
     */
    readonly _embedded?: Vb365OrganizationBaseEmbedded | null;
}
export enum Vb365OrganizationBaseType {
    Unknown = 'Unknown',
    Microsoft365 = 'Microsoft365',
    OnPremises = 'OnPremises',
    Hybrid = 'Hybrid'
};
export enum Vb365OrganizationBaseRegion {
    Unknown = 'Unknown',
    Default = 'Default',
    Germany = 'Germany',
    China = 'China',
    USDefence = 'USDefence',
    USGovernment = 'USGovernment'
};
export enum Vb365OrganizationBaseCloudAuthenticatedMethod {
    Unknown = 'Unknown',
    Modern = 'Modern',
    ModernWithLegacyProtocols = 'ModernWithLegacyProtocols',
    Basic = 'Basic'
};
export enum Vb365OrganizationBaseProtectedServices {
    Unknown = 'Unknown',
    MicrosoftSharePointServer = 'MicrosoftSharePointServer',
    SharePointOnlineAndOneDriveForBusiness = 'SharePointOnlineAndOneDriveForBusiness',
    MicrosoftExchangeServer = 'MicrosoftExchangeServer',
    ExchangeOnline = 'ExchangeOnline',
    MicrosoftTeams = 'MicrosoftTeams',
    MicrosoftTeamsChats = 'MicrosoftTeamsChats'
};



